// extracted by mini-css-extract-plugin
export var closeButton = "_jt-1";
export var closeX = "_jt-3";
export var container = "_jt-0";
export var image = "_jt-2";